import React from "react";
import { Helmet } from "react-helmet-async";
import "./Pricing.css";
import Contact from "./Contact";

const PricingPage = () => {
    return (
        <>
            <Helmet>
                <title>Pricing | AptoWebsites - Affordable Real Estate Website Plans</title>
                <meta name="description" content="Transparent, affordable pricing for real estate agent and brokerage websites. Compare plans and features for your business." />
                <meta name="keywords" content="pricing, real estate website pricing, agent website cost, brokerage website cost, AptoWebsites" />
                <meta property="og:title" content="Pricing | AptoWebsites" />
                <meta property="og:description" content="Transparent, affordable pricing for real estate agent and brokerage websites. Compare plans and features for your business." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://aptowebsites.com/pricing" />
                <meta property="og:image" content="https://aptowebsites.com/og-image.jpg" />
                <link rel="canonical" href="https://aptowebsites.com/pricing" />
            </Helmet>
            <div className="pricing-page-container">
                <header className="pricing-intro">
                    <p className="section-eyebrow">Simple, transparent pricing</p>
                    <h1>Plans built for your next move.</h1>
                    <p>Choose the website or social media support that fits the way you grow your real estate business.</p>
                </header>
                <main className="pricing-main">
                    <Contact />
                </main>
            </div>
        </>
    );
};

export default PricingPage;
